import gsap from "gsap";
import {Power4} from "gsap/gsap-core";
import Header from "../../Header/Header";
import Navigation from "../Main/Navigation.main";

gsap.registerPlugin(Power4);

const NavButton = {
    el: null,
    scrollDirection: 1,

    init(el) {
        el = el ? el : $('body');
        this.el = el.find('[component="NavButton"]');
        if (!this.el.length) return;

        this.bind();
    },

    bind() {
        this.el.click((evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            const el = $(evt.currentTarget);

            if (!el.is('.open')) {
                this.open();
            } else {
                this.close();
            }
        });
    },

    open(){
        this.el.removeClass('closing').addClass('open');
        Navigation.show();
    },

    close(){
        this.el.removeClass('open').addClass('closing');
        Navigation.hide();
    },

    reset(){
        this.el.removeClass('open');
    }
}

export default NavButton;